import { Fragment } from "react";
import { SKTCheckbox } from "./SKTCheckbox";

export const SKTAcceptTermsAndConditions = ({ data }) => {
  return (
    <SKTCheckbox
      id="accept_tc"
      data={data}
      label={
        <Fragment>
          Hyväksyn{" "}
          <a href="/kayttoehdot" target="_blank">
            palvelun käyttöehdot
          </a>
        </Fragment>
      }
    />
  );
};
